<template>
  <!-- 封装弹框 -->
  <div class="popup">
    <el-dialog
      :title="$lang(dialogTitle)"
      :visible.sync="visible"
      :width="popupWidth"
      :before-close="handleClose"
      :showClose="showClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close="true"
    >
      <div class="notice-box">
        <div class="notice-title notice-label ">
          <span class="notice-top" v-if="noticeContent.noticeLevel == '1'">{{ $lang('置顶') }}</span>
          <span class="notice-mustRead" v-else-if="noticeContent.noticeLevel == '2'">{{ $lang('必读') }}</span>
          <span class="notice-major" v-else-if="noticeContent.noticeLevel == '3'">{{ $lang('重要') }}</span>
          <span class="notice-ordinary" v-else-if="noticeContent.noticeLevel == '4'">{{ $lang('普通') }}</span>
          {{ noticeContent.title }}
        </div>
        <div class="notice-content" v-html="noticeContent.content"></div>
        <div class="notice-url" v-if="noticeContent.fileUrl">
          {{ $lang('附件') }}：<a @click="download(noticeContent.downloadUrl, JSON.parse(noticeContent.fileUrl)[0].name)">{{ JSON.parse(noticeContent.fileUrl)[0].name }}</a>
        </div>
      </div>
      <div slot="footer">
        <div class="noticeBut">
          <div class="butNo" v-if="!noticeType && noticeContent.openForce === 1">{{ $lang('倒计时') }}{{ noticeItem }}{{ $lang('秒') }}</div>
          <div class="butYes" v-else-if="(noticeContent.openForce === 0 && noticeContent.isRead !== 1) || (noticeItem === 0 && !showClose)" @click="Cancel">
            {{ $lang('已阅读') }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    noticeContent: {
      type: Object,
      default: () => {}
    },
    dialogTitle: {
      type: String,
      default: '公告消息'
    },
    showClose: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    popupWidth: {
      type: String,
      default: '550px'
    }
  },
  data() {
    return {
      noticeType: true,
      noticeItem: 5
    }
  },
  watch: {
    showClose(val) {
      this.noticeType = val
    }
  },
  methods: {
    Cancel() {
      this.$emit('Read')
    },
    getBlob(url) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response)
          }
        }
        xhr.send()
      })
    },
    saveFile(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename)
      } else {
        const link = document.createElement('a')
        const body = document.querySelector('body')
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.style.display = 'none'
        body.appendChild(link)
        link.click()
        body.removeChild(link)
        window.URL.revokeObjectURL(link.href)
      }
    },
    download(url, filename) {
      this.getBlob(url).then(blob => {
        this.saveFile(blob, filename)
      })
    },
    countDown() {
      const clock = window.setInterval(() => {
        this.noticeItem--
        if (this.noticeItem === 0) {
          window.clearInterval(clock)
          this.noticeType = true
        }
      }, 1000)
    },
    startCountdown() {
      this.noticeType = false
      this.noticeItem = 5
      this.countDown()
    },
    handleClose() {
      this.$emit('handleClose')
    }
  }
}
</script>
<style lang="scss" scoped>
.notice-url {
  margin-top: 24px;
  a {
    font-size: 14px;
    color: #2d7cff;
    cursor: pointer;
  }
}
.notice-box {
  margin-top: -4px;
}
.notice-content {
  overflow: auto;
  height: 400px;
}
.notice-title {
  font-size: 16px;
  color: #333333;
  text-align: center;
  font-weight: SC;
  opacity: 1;
  margin-bottom: 36px;
  line-height: 32px;
}
.notice-label {
  span {
    display: inline-block;
    border-radius: 10px;
    padding: 0 15px;
    height: 20px;
    opacity: 1;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
  }
  .notice-top {
    background: rgba(230, 0, 18, 0.1);
    color: #e60012;
  }
  .notice-mustRead {
    border: 1px solid rgba(230, 0, 18, 0.2);
    color: #e60012;
  }
  .notice-major {
    color: #fa8b14;
    border: 1px solid rgba(250, 139, 20, 0.2);
  }
  .notice-ordinary {
    color: #999999;

    border: 1px solid #eeeeee;
  }
}
.noticeBut {
  text-align: center;
  margin-top: 28px;
  div {
    display: inline-block;
    font-size: 16px;
    height: 40px;
    opacity: 1;
    line-height: 40px;
  }
  .butYes {
    width: 96px;
    background: #e60012;
    border-radius: 8px;
    color: #ffffff;
    cursor: pointer;
  }
  .butNo {
    width: 122px;
    height: 40px;
    opacity: 1;
    background: #edeef3;
    border: 1px solid #dddddd;
    border-radius: 9px;
    color: #999999;
  }
}
</style>
